<template>
    <div
        v-if="can('view', 'service')"
        class="space-x-1 rounded-lg bg-gray-100 dark:bg-gray-900 p-0.5"
        aria-orientation="horizontal">
        <NuxtLink
            :to="(isServicePage) ? '/' : '/service'">
            <BaseButton
                class="w-full"
                color="secondary">
                <div class="flex items-center">
                    <Icon name="heroicons:chevron-right" />
                    <span class="text-xs">
                        <span v-if="isServicePage">Zum Antragsbereich</span>
                        <span v-else>Zum Verwaltungsbereich</span>
                    </span>
                </div>
            </BaseButton>
        </NuxtLink>
    </div>
</template>

<script setup>
import {useAbility} from "@casl/vue"
import {useRoute} from "vue-router"

const route = useRoute()
const { can } = useAbility()

const isServicePage = computed(() => {
    return route.path.startsWith('/service')
})
</script>